module.exports = __webpack_public_path__ + "static/media/4342.dc7ce8a1.jpg";